/***
 * CMS Key Prefix Legends
 * p_ = placeholder text
 * l_ = label text
 * d_ = descripion text
 * b_ = button text
 * m_ = message text
 * t_ = title text
 * h_ = heading text
 ***/

export default {
  // Navbar CMS
  l_app_title: 'Lean Model Canvas',
  l_app_version: '',
  l_save: 'Save',
  l_open: 'open',
  l_export_to_svg: 'Export to SVG',
  l_presentation_mode: 'Presentation Mode',
  l_view_on_github: 'View on GitHub',
  url_app_github: 'https://github.com/shubham-thakare/BMC-Creator',
  default_export_file_name: 'Lean Model Canvas',

  // Common Messages CMS
  p_get_started: 'Hover mouse cursor on section to add notes',
  p_edit_note_title: 'Edit note title...',
  p_edit_note_desc: 'Edit description',
  b_cancel: 'Cancel',
  b_submit: 'Submit',
  b_close: 'Close',
  b_save: 'Save',
  b_delete: 'Delete',
  b_edit: 'Edit',
  t_menu: 'Menu',
  m_failed_to_open_file: 'Failed to open file!',

  // BMCScreen CMS
  p_canvas_title: 'Edit title...',
  p_na: 'NA',
  l_version: 'Version',
  l_date: 'Date',
  l_key_partners: 'Key Partners',
  l_key_activities: 'Key Activities',
  l_key_resources: 'Key Resources',
  l_value_propositions: 'Value Propositions',
  l_customer_relationships: 'Customer Relationships',
  l_channels: 'Channels',
  l_customer_segments: 'Customer Segments',
  l_cost_structure: 'Cost Structure',
  l_revenue_streams: 'Revenue Streams',
  l_problem: 'Problem',
  l_solution: 'Solution',
  l_key_metrics: 'Key Metrics',
  l_unique_value_propositions: 'Unique Value Propositions',
  l_unfair_advantages: 'Unfair Advantages',

  /** Popover Screens **/
  // Channels CMS
  c_q_one:
    'Through which channels do our customer segments want to be reached?',
  c_q_two: 'How are we reaching them now?',
  c_q_three: 'How are our channels integrated?',
  c_q_four: 'Which ones work best?',
  c_q_five: 'Which ones are most cost-efficient?',
  c_q_six: 'How are we integrating them with customer routines?',
  l_channel_phases: 'CHANNEL PHASES',
  l_cp_one: '1. Awareness',
  d_cp_one:
    "How do we raise awareness about our company's products and services?",
  l_cp_two: '2. Evaluation',
  d_cp_two:
    "How do we help customers evaluate our organization's value proposition?",
  l_cp_three: '3. Purchase',
  d_cp_three:
    'How do we allow customers to purchase specific products and services?',
  l_cp_four: '4. Delivery',
  d_cp_four: 'How do we deliver a value proposition to customers?',
  l_cp_five: '5. After sales',
  d_cp_five: 'How do we provide post-purchase customer support?',

  // CostStructure CMS
  cs_q_one: 'What are the most important costs inherent in our business model?',
  cs_q_two: 'Which key resources are most expensive?',
  cs_q_three: 'Which key activities are most expensive?',
  cs_d_title_one: 'IS YOUR BUSINESS MORE',
  d_cs_one:
    'Cost driven (leanest cost structure, low price value proposition, maximum automation, extensive outsourcing)',
  d_cs_two:
    'Value driven (focused on value creation, premium value proposition)',
  cs_d_title_two: 'SAMPLE CHARACTERISTICS',
  d_cs_three: 'Fixed costs (salaries, rents, utilities)',
  d_cs_four: 'Variable costs',
  d_cs_five: 'Economies of scale',
  d_cs_six: 'Economies of scope',

  // CustomerRelationship CMS
  cr_q_one: '',
  cr_q_two: '',
  cr_q_three: '',
  cr_q_four: '',
  cr_d_title: 'Pointers',
  d_cr_one:
    'This is the most difficult to block to answer. However, do try to think about this as having an unfair advantage can help when it comes to seeking partners & investors.',
  d_cr_two:
    'Unfair advantage can be insider information, a dream team, getting expert endorsements, existing customers ',
  d_cr_three: '',
  d_cr_four: '',
  d_cr_five: '',
  d_cr_six: '',

  // CustomerSegments CMS
  cseg_q_one: 'For whom are we creating value?',
  cseg_q_two: 'Who are our most important customers?',
  d_cseg_one: 'Mass market',
  d_cseg_two: 'Niche market',
  d_cseg_three: 'Segmented',
  d_cseg_four: 'Diversified',
  d_cseg_five: 'Multi-sided platform',

  // KeyActivities CMS
  ka_q_one: 'What are the key solution that we will provide to our customers?',
  ka_q_two: '',
  ka_q_three: '',
  ka_q_four: '',
  d_ka_one: '',
  d_ka_two:
    'Finding a solution to the problem is the golden egg! You’re not going to get this right off the first bat.',
  d_ka_three: 'Problem solving',
  d_ka_four: 'Platform/Network',

  // KeyPartners CMS
  kp_q_one: 'What are the problems we are trying to solve?',
  kp_q_two: 'Who are our key stakeholders?',
  kp_q_three: 'Which key resource are we trying to build?',
  kp_q_four: '',
  d_kp_one: 'Also list existing alternatives',
  d_kp_two: 'How are they solved now?',
  d_kp_three: '',
  d_kp_four: '',

  // KeyResources CMS
  kr_q_one: 'How can we measure our success?',
  kr_q_two:
    'What are the numbers that quantify our business? Profit, sales, revenue',
  kr_q_three: '',
  kr_q_four: '',
  kr_d_title: '',
  d_kr_one: '',
  d_kr_two:
    'Every business, no matter what industry or size, will have some key metrics that are used to monitor performance.',
  d_kr_three: '',
  d_kr_four: '',

  // RevenueStreams CMS
  rs_q_one: 'For what value are our customers really willing to pay?',
  rs_q_two: 'For what do they currently pay?',
  rs_q_three: 'How are they currently paying?',
  rs_q_four: 'How would they prefer to pay?',
  rs_q_five:
    'How much does each revenue stream contribute to overall revenues?',
  rs_table_head_first: 'Types',
  rs_table_head_second: 'Fixed Pricing',
  rs_table_head_third: 'Dynamic Pricing',
  rs_table_tr_one_td_one: 'Asset sale',
  rs_table_tr_one_td_two: 'List price',
  rs_table_tr_one_td_three: 'Negotiation (bargaining)',
  rs_table_tr_two_td_one: 'Usage fee',
  rs_table_tr_two_td_two: 'Product feature dependent',
  rs_table_tr_two_td_three: 'Yield management',
  rs_table_tr_three_td_one: 'Subscription fees',
  rs_table_tr_three_td_two: 'Customer segment',
  rs_table_tr_three_td_three: 'Real-time-market',
  rs_table_tr_four_td_one: 'Lending/Renting/Leasing',
  rs_table_tr_four_td_two: 'dependent',
  rs_table_tr_five_td_one: 'Licensing',
  rs_table_tr_five_td_two: 'Volume dependent',
  rs_table_tr_six_td_one: 'Brokerage fees',
  rs_table_tr_seven_td_one: 'Advertising',

  // Value Propositions
  vp_q_one: 'What value do we deliver to the customer?',
  vp_q_two: "Which one of our customer's problems are we helping to solve?",
  vp_q_three:
    'What bundles of products and services are we offering to each customer segment?',
  vp_q_four: 'Which customer needs are we satisfying?',
  vp_d_title: 'CHARACTERISTICS',
  d_vp_one: '',
  d_vp_two: 'Performance',
  d_vp_three: 'Customization',
  d_vp_four: '',
  d_vp_five: '',
  d_vp_six: '',
  d_vp_seven: '',
  d_vp_eight: '',
  d_vp_nine: '',
  d_vp_ten: '',
  d_vp_eleven: '',

  // NoteDialog Component CMS
  l_note_background_color: 'Note background color',
  l_note_text_color: 'Note text color',
  b_reset_color: 'Reset Colors',
  l_sample_note_title: 'Note Title Preview',
  l_sample_note_description: 'Note description preview',

  // DocContainer Component CMS
  l_useful_tips: 'Useful Tips',
  l_tip: 'Update Canvas Title, Version, and Effective Date from the header',
  l_tip_1: 'Click on section title to see hints',
  l_tip_2_1: 'Click on',
  l_tip_2_2: 'button placed at top right to add new notes',
  l_tip_3: 'Click on note to see menu',
  l_tip_4: 'Open side navigation bar to',
  l_tip_menu_option_1: 'Save File',
  l_tip_menu_option_2: 'Open Existing File',
  l_tip_menu_option_3: 'Start Presentation Mode',

  // Joyride Steps

  joyrideSteps: [
    {
      target: '.joyride-first-step',
      content: 'To see all the options and to perform various operations.',
      hideCloseButton: true,
      disableBeacon: true,
    },
    {
      target: '.joyride-second-step',
      content: 'Add a title to your canvas.',
      hideCloseButton: true,
    },
    {
      target: '.joyride-third-step',
      content: 'Update canvas version number here.',
      hideCloseButton: true,
    },
    {
      target: '.joyride-fourth-step',
      content: 'Update canvas effective date here.',
      hideCloseButton: true,
    },
    {
      target: '.joyride-fifth-step',
      content: 'See hints by simply clicking on the title of each section.',
      hideCloseButton: true,
    },
    {
      target: '.joyride-sixth-step',
      content: 'To add new notes, click on the + (add) button.',
      hideCloseButton: true,
    },
  ],
};
